import { __decorate } from "tslib";
import { Component, Prop } from "vue-property-decorator";
import { modalMixins } from "@/mixins/modal.js";
import Modal from "@/components/Modal.vue";
import { mapGetters, mapMutations } from "vuex";
import ModalMixin from "@/mixins/modal-mixin";
import InvoiceTable from "@/components/Invoice/InvoiceTable.vue";
import CompanyPrintHeader from "@/components/Company/CompanyPrintHeader.vue";
let InvoiceSummaryPrint = class InvoiceSummaryPrint extends ModalMixin {
    id;
    removeFromStore;
    findInvoicesStore;
    invoiceIds = [];
    customerId = '';
    getMyCompany;
    getCustomer;
    get invoices() {
        return this.findInvoicesStore({ query: { _id: { $in: this.invoiceIds } } }).data;
    }
    get customer() {
        return this.getCustomer(this.customerId);
    }
    hidden() {
        var $printSection = document.getElementById("printSection");
        if ($printSection) {
            $printSection.remove();
        }
    }
    print() {
        // @ts-ignore
        var domClone = document.getElementById('printContent').cloneNode(true);
        let printSection = document.getElementById("printSection");
        if (!printSection) {
            printSection = document.createElement("div");
            printSection.id = "printSection";
            document.body.appendChild(printSection);
        }
        // @ts-ignore
        printSection.innerHTML = "";
        // @ts-ignore
        printSection.appendChild(domClone);
        window.onafterprint = () => {
            this.close();
        };
        setTimeout(function () {
            window.print();
        }, 500);
    }
    shown() {
        const { Invoice } = this.$FeathersVuex;
        let data = Invoice.getFromStore('temp');
        if (!data)
            return;
        this.invoiceIds = data.model.selected;
        this.customerId = data.model.customerId;
        this.removeFromStore('temp');
        setTimeout(this.print, 0); // makes sure content is rendered before printing the page
    }
    close() {
        this.$root.$emit('bv::hide::modal', this.id);
    }
};
__decorate([
    Prop({ type: String, required: true })
], InvoiceSummaryPrint.prototype, "id", void 0);
InvoiceSummaryPrint = __decorate([
    Component({
        components: { InvoiceTable, Modal, CompanyPrintHeader },
        mixins: [modalMixins],
        methods: {
            ...mapMutations('invoices', { removeFromStore: 'removeItem' }),
        },
        computed: {
            ...mapGetters('invoices', { findInvoicesStore: 'find' }),
            ...mapGetters('invoices', { getInvoice: 'get' }),
            ...mapGetters('customers', { getCustomer: 'get' }),
        }
    })
], InvoiceSummaryPrint);
export default InvoiceSummaryPrint;
